export var ViewModes;
(function (ViewModes) {
    ViewModes["Site"] = "Site";
    ViewModes["Editor"] = "Editor";
    ViewModes["Preview"] = "Preview";
    ViewModes["Dashboard"] = "Dashboard";
})(ViewModes || (ViewModes = {}));
//# sourceMappingURL=view-modes.js.map